import { useContext } from "react";
import { UpdateUserFavoriteProductContext } from "../customContext/userFavoriteProductProvider";

export function useUpdateUserFavoriteProductCtx(){
    const ctx = useContext(UpdateUserFavoriteProductContext);
    if(!ctx){
        throw new Error('useUpdateUserFavoriteProductCtx must be used within UserFavoriteProduct context')
    };
    return ctx
}